module.exports = __webpack_public_path__ + "static/altana-jesienia-1aac251a11ee4b81e8617ff627c9ed98.jpg";